import { render, staticRenderFns } from "./aboutMy.vue?vue&type=template&id=21658590&scoped=true&"
import script from "./aboutMy.vue?vue&type=script&lang=js&"
export * from "./aboutMy.vue?vue&type=script&lang=js&"
import style0 from "./aboutMy.vue?vue&type=style&index=0&id=21658590&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21658590",
  null
  
)

export default component.exports